import { createApi } from '@reduxjs/toolkit/query/react'
import { isMobilePlatform } from '@/lib/platform'
import type {
	CasinoGamesApiResponse,
	CasinoGamesRequest,
	CasinoLaunchRequest,
	CasinoLaunchResponse,
	CasinoProvidersApiResponse,
	CasinoProvidersRequest,
	CasinoTypesApiResponse,
} from '@/types/casino'
import { playerBaseQuery } from './playerBaseQuery'

export const casinoApi = createApi({
	reducerPath: 'casinoApi',
	baseQuery: playerBaseQuery,
	tagTypes: ['CasinoTypes', 'CasinoGames', 'CasinoProviders'],
	endpoints: (builder) => ({
		getCasinoTypes: builder.query<CasinoTypesApiResponse, void>({
			query: () => '/casinos/types',
			providesTags: ['CasinoTypes'],
		}),
		getLobbyCasinoTypes: builder.query<CasinoTypesApiResponse, void>({
			query: () => ({
				url: '/casinos/types',
				params: { is_lobby: true },
			}),
			providesTags: ['CasinoTypes'],
		}),
		getCasinoGames: builder.query<CasinoGamesApiResponse, CasinoGamesRequest>({
			query: (params) => ({
				url: '/casinos/casino',
				params: {
					...params,
					is_mobile: isMobilePlatform(),
				},
			}),
			providesTags: ['CasinoGames'],
		}),
		getCasinoProviders: builder.query<CasinoProvidersApiResponse, CasinoProvidersRequest>({
			query: (params) => ({
				url: '/casinos/providers',
				params,
			}),
			providesTags: ['CasinoProviders'],
		}),
		launchCasinoGame: builder.query<CasinoLaunchResponse, CasinoLaunchRequest>({
			query: (params) => ({
				url: '/casinos/launch',
				params,
			}),
		}),
		launchCasinoDemo: builder.query<CasinoLaunchResponse, CasinoLaunchRequest>({
			query: (params) => ({
				url: '/casinos/demo',
				params,
			}),
		}),
	}),
})

export const {
	useGetCasinoTypesQuery,
	useGetLobbyCasinoTypesQuery,
	useGetCasinoGamesQuery,
	useGetCasinoProvidersQuery,
	useLazyLaunchCasinoGameQuery,
	useLazyLaunchCasinoDemoQuery,
} = casinoApi
